import { render, staticRenderFns } from "./BaseTextareaGroupWithProvider.vue?vue&type=template&id=83f9e1fe&"
import script from "./BaseTextareaGroupWithProvider.vue?vue&type=script&lang=js&"
export * from "./BaseTextareaGroupWithProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports